"use client";

import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  question: "What services does StrategyAI Partners provide?",
  answer: "We specialize in AI Governance, Executive Advisory Services, and strategic consulting to help organizations navigate the complexities of artificial intelligence adoption. Our team ensures your AI initiatives are ethical, compliant, and aligned with your business goals."
}, {
  question: "How does the AI Governance Executive Advisory Service work?",
  answer: "Our advisory service is designed for C-suite executives and board members. We provide tailored guidance on risk management, regulatory compliance, and strategic implementation of AI technologies, ensuring your leadership is equipped to make informed decisions."
}, {
  question: "Who are your typical clients?",
  answer: "We work with a diverse range of clients, from mid-sized enterprises to large multinational corporations across various industries including finance, healthcare, and technology. Our ideal partners are organizations looking to scale their AI capabilities responsibly."
}, {
  question: "Can you help with regulatory compliance for AI?",
  answer: "Absolutely. Staying ahead of the rapidly evolving regulatory landscape is a core part of our offering. We help you understand and adhere to current and upcoming AI regulations, such as the EU AI Act and other global standards."
}, {
  question: "How do we get started with an engagement?",
  answer: "Starting is simple. You can reach out to us through our Contact page to schedule an initial consultation. We'll discuss your specific needs, assess your current AI maturity, and propose a tailored roadmap for our partnership."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="frequently-asked-questions" className="bg-light-background py-24 sm:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary/10 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full mb-4">
              <MessageCircle className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-4xl font-display font-bold tracking-tight text-foreground-light mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-muted-foreground">
              Find answers to common questions about our AI governance and
              strategic advisory services.
            </p>
          </div>

          <div className="bg-white/50 backdrop-blur-sm rounded-2xl border border-border/50 shadow-soft p-6 sm:p-8">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b-border/60 last:border-0" data-index={i}>
                  <AccordionTrigger className="text-left text-base font-medium text-foreground-light hover:text-primary-dark hover:no-underline py-5 transition-colors">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground mb-6">
              Still have questions? We're here to help.
            </p>
            <Button asChild size="lg" className="bg-primary text-foreground-primary px-7 py-3 rounded-sm hover:bg-primary-hover active:bg-primary-active transition-all group">
              <Link to="/ContactPage">
                Contact Support
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}